import produce from 'immer';
import {
  BRANDS_START,
  BRANDS_SUCCESS,
  BRANDS_FAILED,
  GET_STORE_BRANDS_START,
  GET_STORE_BRANDS_SUCCESS,
  GET_STORE_BRANDS_FAILED,
  GET_ALL_BRANDS_START,
  GET_ALL_BRANDS_SUCCESS,
  GET_ALL_BRANDS_FAILED
} from '../actions/brands';

import {
  CHANGE_ACTIVE_STORE_SUCCESS,
} from '../actions/user';


const initialState = {
  brandsData: [],
  allBrands: [],
  storeBrands: [],
  browseBrandsGifts: [],
  directFulfillmentBrands: [],
  affiliateBrands: [],
  browseBrandsProducts: [],
  browseBrandsTreatments: [],
  loadingStoreBrands: false,
  loadingAllBrands: false,
  loading: false,
  error: false
};

const formReducer = produce((state: IBrandsState = initialState, action) => {
  switch (action.type) {
    case BRANDS_START: {
      state.error = false;
      state.loading = true;
      break;
    }
    case BRANDS_SUCCESS: {
      const {data, directDropShipAttr, affiliateAttr, skuLike} = action;

      if (directDropShipAttr == '1') {
        state.brandsData = [];
        state.directFulfillmentBrands = data;
      } else if (affiliateAttr == '1') {
        state.brandsData = [];
        state.affiliateBrands = data;
      } else if (skuLike == 'TREAT') {
        state.brandsData = [];
        state.browseBrandsTreatments = data;
      } else if (skuLike == 'PROD') {
        state.brandsData = [];
        state.browseBrandsProducts = data;
      } else if (skuLike == 'GIFT') {
        state.brandsData = [];
        state.browseBrandsGifts = data;
      } else {
        state.brandsData = data;
        state.directFulfillmentBrands = [];
      }

      state.error = false;
      state.loading = false;

      break;
    }
    case BRANDS_FAILED: {
      state.error = true;
      state.loading = false;
      break;
    }
    case GET_STORE_BRANDS_START: {
      state.loadingStoreBrands = true;
      break;
    }
    case GET_STORE_BRANDS_SUCCESS: {
      const {data} = action;

      state.storeBrands = data;
      state.loadingStoreBrands = false;

      break;
    }
    case GET_STORE_BRANDS_FAILED: {
      state.loadingStoreBrands = false;
      break;
    }

    case GET_ALL_BRANDS_START: {
      state.loadingAllBrands = true;
      break;
    }

    case GET_ALL_BRANDS_SUCCESS: {
      const {data} = action;

      state.allBrands = data;
      state.loadingAllBrands = false;

      break;
    }

    case GET_ALL_BRANDS_FAILED: {
      state.loadingAllBrands = false;
      break;
    }

    case CHANGE_ACTIVE_STORE_SUCCESS: {
      state.storeBrands = initialState.storeBrands;
      state.allBrands = initialState.allBrands;
      state.affiliateBrands = initialState.affiliateBrands;
      state.browseBrandsProducts = initialState.browseBrandsProducts;
      state.browseBrandsTreatments = initialState.browseBrandsTreatments;
      state.browseBrandsGifts = initialState.browseBrandsGifts;

      break;
    }
    default:
      break;
  }
}, initialState);

export default formReducer;
